import { ServiceTokens } from "$src/domain/ServiceTokens";
import { Customer } from "$src/domain/customers/Customer";
import type { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetCustomersById {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository) {}

    async execute(groupStoreId: number, customerId: string): Promise<Customer> {
        return this.customerRepository.getCustomerById(groupStoreId.toString(), customerId);
    }
}

export const GetCustomersByIdToken = Symbol('GetCustomersByIdToken');    

